import styled from 'styled-components'
import LoadingSpinner from '../../assets/LoadingSpinner'

const Spinner = styled(LoadingSpinner)`
  position: relative;
  z-index: 1;
  margin: 120px auto;
  display: block;
  g {
    fill: ${(props) => props.theme.colors.blue};
  }
`

export default Spinner
